import { Code } from "@mantine/core"
import type { ReactNode } from "react"

export function DocsCallout({ children, title }: { children: ReactNode; title?: string }) {
  return (
    <aside className="app-docs-callout">
      {title ? <strong>{title}</strong> : null}
      <div>{children}</div>
    </aside>
  )
}

export function DocsCodeBlock({
  children,
  language = "text",
}: {
  children: string
  language?: string
}) {
  return (
    <Code block className="app-docs-code" data-language={language}>
      {children.trim()}
    </Code>
  )
}

export function DocsSteps({ children }: { children: ReactNode }) {
  return <ol className="app-docs-steps">{children}</ol>
}
